module.exports = __webpack_public_path__ + "img/receipt_bankinfo_help.541384da.png";